import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import Lenis from 'lenis';

@Injectable({
  providedIn: 'root',
})
export class LenisService implements OnDestroy {
  private lenis?: Lenis;
  private rafId?: number;

  constructor(private router: Router) {}

  /**
   * Initializes Lenis smooth scrolling ONLY on public and customer routes.
   * Completely disabled on all Admin routes.
   */
  init(): void {
    if (typeof window === 'undefined') return;

    // Strict guard: NEVER run Lenis on any Admin routes
    const currentUrl = (this.router.url || window.location.pathname || '').toLowerCase();
    if (currentUrl.startsWith('/admin') || currentUrl.includes('/admin/')) {
      console.log('[Lenis] Initialization skipped: Admin route is active.');
      this.destroy();
      return;
    }

    if (this.lenis) {
      return;
    }

    this.lenis = new Lenis({
      smoothWheel: true,
      gestureOrientation: 'vertical',
      lerp: 0.12,
    });

    const raf = (time: number) => {
      this.lenis?.raf(time);
      this.rafId = window.requestAnimationFrame(raf);
    };

    this.rafId = window.requestAnimationFrame(raf);
    console.log('[Lenis] Smooth scrolling active for customer/public pages.');
  }

  ngOnDestroy(): void {
    this.destroy();
  }

  /**
   * Destroys Lenis instance, stops the animation frame loop,
   * and strips any Lenis classes and styles from the document root.
   */
  destroy(): void {
    if (this.rafId) {
      window.cancelAnimationFrame(this.rafId);
      this.rafId = undefined;
    }
    if (this.lenis) {
      this.lenis.destroy();
      this.lenis = undefined;
    }
    if (typeof document !== 'undefined') {
      document.documentElement.classList.remove('lenis', 'lenis-smooth', 'lenis-scrolling', 'lenis-stopped');
      document.documentElement.style.removeProperty('scroll-behavior');
    }
    console.log('[Lenis] Smooth scrolling destroyed (Native scrolling active for Admin).');
  }
}
